<template >
  <div>
    <Banner />
    <PdkHeader />
    <main>
      <div class="search-widget">
        <carousel
          class="d-none d-md-block"
          :items="1"
          :dots="false"
          :nav="false"
          :autoplay="true"
          :smartSpeed="2500"
          :autoplayTimeout="8500"
          dir="ltr"
        >
          <img src="/img/etr7333r copy_dariushgroup.webp" />

          <img src="/img/0sac5c_dariushgroup.webp" />
        </carousel>

        <div class="mobiletop-banner d-md-none">
          <img src="/img/cmolp12.jpg" />
        </div>
        <div id="search_2">
          <div class="search-title">
            <h2>{{ $t("HomeHeader.ReservationSystem") }}</h2>
          </div>

          <div class="search-box" v-if="checkSourceId && getAccessibility">
            <ul class="nav nav-tabs reserve-explorer">
              <li
                class="reserve-explorer-item"
                @click="tabIndex = hotelCurrentTab"
                v-if="hotelAccessibility"
              >
                <div
                  href="#tours"
                  data-toggle="tab"
                  :class="{ active_tab: tabIndex === hotelCurrentTab }"
                  class="btn_tab active show reserve-explorer-tab"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 402.06 377.82"
                    style="enable-background: new 0 0 402.06 377.82"
                    xml:space="preserve"
                  >
                    <path
                      d="M348.59,327.08h-41.7c-5.25,0-9.5-4.25-9.5-9.5s4.25-9.5,9.5-9.5h39.69V161.34h-60.13V310.1c0,9.37-7.62,16.99-16.99,16.99  H130.46c-1.12,0-2.19-0.19-3.19-0.55c-1.37,0.36-2.81,0.55-4.29,0.55H60.95c-9.37,0-16.99-7.62-16.99-16.99V161.47  c0-9.37,7.62-16.99,16.99-16.99h32.08c5.25,0,9.5,4.25,9.5,9.5s-4.25,9.5-9.5,9.5H62.97v144.6h57.99V69.51  c0-9.37,7.62-16.99,16.99-16.99h131.52c9.37,0,16.99,7.62,16.99,16.99v45.98c0,5.25-4.25,9.5-9.5,9.5s-9.5-4.25-9.5-9.5V71.52  h-127.5v236.56h24.84v-53.59c0-9.37,7.62-16.98,16.98-16.98h42.77c9.37,0,16.99,7.62,16.99,16.98v53.59h25.91V159.33  c0-9.37,7.62-16.99,16.99-16.99h64.16c9.37,0,16.99,7.62,16.99,16.99V310.1C365.58,319.46,357.96,327.08,348.59,327.08z   M183.8,308.08h38.74v-51.57H183.8V308.08z M317.23,253.3c-5.25,0-9.5-4.25-9.5-9.5v-49.9c0-5.25,4.25-9.5,9.5-9.5s9.5,4.25,9.5,9.5  v49.9C326.73,249.05,322.47,253.3,317.23,253.3z M93.39,253.3c-5.25,0-9.5-4.25-9.5-9.5v-49.9c0-5.25,4.25-9.5,9.5-9.5  s9.5,4.25,9.5,9.5v49.9C102.89,249.05,98.63,253.3,93.39,253.3z M184.27,191.07c-0.47,0-0.94-0.04-1.42-0.11  c-5.19-0.78-8.76-5.62-7.99-10.8c1.26-8.43,9.66-8.59,15.22-8.69c3.26-0.06,7.75-0.04,13.35,0.07c9.41,0.18,18.91,0.54,19.01,0.54  c5.24,0.2,9.33,4.61,9.13,9.85c-0.2,5.24-4.61,9.35-9.85,9.13c-13.6-0.52-29.92-0.83-34.42-0.49  C186.34,190.9,185.32,191.07,184.27,191.07z M193.65,182.99c-0.08,0.5-0.19,0.99-0.34,1.46  C193.46,183.99,193.57,183.51,193.65,182.99z M166.01,131.21c-0.89,0-1.79-0.13-2.69-0.39c-5.03-1.48-7.91-6.76-6.43-11.8  c1.99-6.74,8.49-7.05,11.98-7.21c2.1-0.1,4.99-0.17,8.83-0.2c6.24-0.06,14.89-0.04,25.71,0.07c18.36,0.18,36.91,0.53,37.09,0.54  c5.25,0.1,9.42,4.44,9.31,9.68c-0.1,5.25-4.44,9.45-9.68,9.31c-30.83-0.6-65.19-0.88-71.54-0.36  C167.77,131.08,166.9,131.21,166.01,131.21z M175.12,124.4c-0.32,1.07-0.81,2.05-1.43,2.9C174.29,126.49,174.79,125.52,175.12,124.4  z"
                    />
                  </svg>

                  <!-- <i class=" icon-hospital"></i> -->
                  <span clas>{{ $t("Hotel") }} </span>
                </div>
              </li>
              <li
                class="reserve-explorer-item"
                @click="tabIndex = tourCurrentTab"
                v-if="tourAccessibility"
              >
                <div
                  href="#tours"
                  data-toggle="tab"
                  :class="{ active_tab: tabIndex === tourCurrentTab }"
                  class="btn_tab active show reserve-explorer-tab"
                >
                  <svg
                    class="hotef"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 846.89 380.67"
                    style="enable-background: new 0 0 846.89 380.67"
                    xml:space="preserve"
                  >
                    <path
                      d="M433.55,272.79c-3.73,0-7.26-2.21-8.78-5.87c-2.01-4.85,0.29-10.4,5.14-12.41l49.1-20.35l-15.42-23.54  c-2.27-3.3-15.88-24.01-9.05-34.78c2.66-4.19,7.56-6.14,12.79-5.08c6.77,1.36,12.94,2.71,18.91,4.01  c32.39,7.07,51.94,11.34,85.31,0.13c1.12-0.38,2.13-0.59,2.87-0.74c0.17-0.04,0.35-0.07,0.52-0.11  c156-80.47,201.72-50.95,214.13-34.5c7.1,9.41,7.81,20.96,1.68,27.47c-19.58,20.83-90.75,46.26-98.8,49.09  c-4.95,1.74-10.37-0.86-12.11-5.81s0.86-10.37,5.81-12.11c20.18-7.1,74.71-28.35,90.21-43.12c-0.27-1.51-1.64-4.9-6.37-8.21  c-10.02-7-53.06-24.48-186.16,44.24c-1.97,1.02-3.81,1.4-5.03,1.66c-0.24,0.05-0.49,0.09-0.73,0.16  c-38.32,12.87-62.25,7.64-95.38,0.41c-2.51-0.55-5.05-1.1-7.65-1.66c1.38,2.93,3.06,5.96,4.63,8.07c0.11,0.15,0.22,0.3,0.32,0.46  l16.96,25.88l9.31-2.97c4.85-1.54,10.06,1,11.81,5.79c1.75,4.78-0.58,10.09-5.29,12.04l-75.09,31.11  C436,272.56,434.77,272.79,433.55,272.79z"
                    />
                    <path
                      d="M477.56,299.9c-3.79,0-7.37-2.28-8.84-6.02c-1.92-4.88,0.48-10.4,5.36-12.32l74.62-29.4c4.88-1.92,10.4,0.48,12.32,5.36  c1.92,4.88-0.48,10.4-5.36,12.32l-74.62,29.4C479.9,299.68,478.72,299.9,477.56,299.9z"
                    />
                    <path
                      d="M629.87,295.5c-8.56,0-16.82-4.56-21.19-12.39l-30.2-54.1c-2.56-4.58-0.92-10.37,3.67-12.92  c4.58-2.56,10.37-0.92,12.92,3.67l30.2,54.1c1.26,2.26,4.03,3.25,6.44,2.3l10.19-4.02c2.96-1.17,4.94-4.09,4.92-7.27l-0.52-75.27  c-0.04-5.25,4.19-9.53,9.43-9.57c0.02,0,0.05,0,0.07,0c5.22,0,9.46,4.21,9.5,9.43l0.52,75.27c0.08,10.98-6.74,21.06-16.95,25.08  l-10.2,4.02C635.81,294.96,632.82,295.5,629.87,295.5z"
                    />
                    <path class="st0" d="M575.53,149.13" />
                    <path
                      d="M575.53,158.63c-0.76,0-1.54-0.09-2.31-0.29c-5.09-1.27-8.19-6.43-6.91-11.52l10.48-41.93c1.63-6.51,6.33-11.87,12.58-14.33  l21.56-8.49c5.18-2.04,10.92-1.63,15.75,1.11c4.77,2.71,8.05,7.34,9,12.73l7.34,35.66c1.06,5.14-2.25,10.16-7.39,11.22  c-5.13,1.06-10.16-2.25-11.22-7.39l-7.28-35.36l-20.8,8.2c-0.55,0.22-0.97,0.69-1.11,1.26l-10.48,41.93  C583.66,155.75,579.79,158.63,575.53,158.63z"
                    />
                    <path
                      d="M360.19,327.62h-41.7c-5.25,0-9.5-4.25-9.5-9.5s4.25-9.5,9.5-9.5h39.69V161.88h-60.13v148.76c0,9.37-7.62,16.99-16.99,16.99  H142.05c-1.12,0-2.19-0.19-3.19-0.55c-1.37,0.36-2.81,0.55-4.29,0.55H72.55c-9.37,0-16.99-7.62-16.99-16.99V162  c0-9.37,7.62-16.99,16.99-16.99h32.08c5.25,0,9.5,4.25,9.5,9.5s-4.25,9.5-9.5,9.5H74.56v144.6h57.99V70.04  c0-9.37,7.62-16.99,16.99-16.99h131.52c9.37,0,16.99,7.62,16.99,16.99v45.98c0,5.25-4.25,9.5-9.5,9.5s-9.5-4.25-9.5-9.5V72.05  h-127.5v236.56h24.84v-53.59c0-9.37,7.62-16.98,16.98-16.98h42.77c9.37,0,16.99,7.62,16.99,16.98v53.59h25.91V159.86  c0-9.37,7.62-16.99,16.99-16.99h64.16c9.37,0,16.99,7.62,16.99,16.99v150.77C377.18,320,369.56,327.62,360.19,327.62z   M195.39,308.62h38.74v-51.57h-38.74V308.62z M328.82,253.84c-5.25,0-9.5-4.25-9.5-9.5v-49.9c0-5.25,4.25-9.5,9.5-9.5  s9.5,4.25,9.5,9.5v49.9C338.32,249.58,334.07,253.84,328.82,253.84z M104.98,253.84c-5.25,0-9.5-4.25-9.5-9.5v-49.9  c0-5.25,4.25-9.5,9.5-9.5s9.5,4.25,9.5,9.5v49.9C114.48,249.58,110.23,253.84,104.98,253.84z M195.87,191.61  c-0.47,0-0.94-0.04-1.42-0.11c-5.19-0.78-8.76-5.62-7.99-10.8c1.26-8.43,9.66-8.59,15.22-8.69c3.26-0.06,7.75-0.04,13.35,0.07  c9.41,0.18,18.91,0.54,19.01,0.54c5.24,0.2,9.33,4.61,9.13,9.85c-0.2,5.24-4.61,9.35-9.85,9.13c-13.6-0.52-29.92-0.83-34.42-0.49  C197.94,191.43,196.92,191.61,195.87,191.61z M205.25,183.53c-0.08,0.5-0.19,0.99-0.34,1.46  C205.06,184.53,205.17,184.04,205.25,183.53z M177.61,131.74c-0.89,0-1.79-0.13-2.69-0.39c-5.03-1.48-7.91-6.76-6.43-11.8  c1.99-6.74,8.49-7.05,11.98-7.21c2.1-0.1,4.99-0.17,8.83-0.2c6.24-0.06,14.89-0.04,25.71,0.07c18.36,0.18,36.91,0.53,37.09,0.54  c5.25,0.1,9.42,4.44,9.31,9.68c-0.1,5.25-4.44,9.45-9.68,9.31c-30.83-0.6-65.19-0.88-71.54-0.36  C179.37,131.62,178.5,131.74,177.61,131.74z M186.72,124.94c-0.32,1.07-0.81,2.05-1.43,2.9  C185.88,127.02,186.38,126.06,186.72,124.94z"
                    />
                  </svg>

                  <span>{{ $t("Hotel") }} + {{ $t("Flight") }}</span>
                </div>
              </li>

              <li
                class="reserve-explorer-item"
                @click="tabIndex = flightCurrentTab"
              >
                <div
                  href="#tours"
                  data-toggle="tab"
                  :class="{ active_tab: tabIndex === flightCurrentTab }"
                  class="btn_tab active show reserve-explorer-tab"
                >
                  <svg
                    class="hotef"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 846.89 380.67"
                    style="enable-background: new 0 0 846.89 380.67"
                    xml:space="preserve"
                  >
                    <path
                      d="M433.55,272.79c-3.73,0-7.26-2.21-8.78-5.87c-2.01-4.85,0.29-10.4,5.14-12.41l49.1-20.35l-15.42-23.54  c-2.27-3.3-15.88-24.01-9.05-34.78c2.66-4.19,7.56-6.14,12.79-5.08c6.77,1.36,12.94,2.71,18.91,4.01  c32.39,7.07,51.94,11.34,85.31,0.13c1.12-0.38,2.13-0.59,2.87-0.74c0.17-0.04,0.35-0.07,0.52-0.11  c156-80.47,201.72-50.95,214.13-34.5c7.1,9.41,7.81,20.96,1.68,27.47c-19.58,20.83-90.75,46.26-98.8,49.09  c-4.95,1.74-10.37-0.86-12.11-5.81s0.86-10.37,5.81-12.11c20.18-7.1,74.71-28.35,90.21-43.12c-0.27-1.51-1.64-4.9-6.37-8.21  c-10.02-7-53.06-24.48-186.16,44.24c-1.97,1.02-3.81,1.4-5.03,1.66c-0.24,0.05-0.49,0.09-0.73,0.16  c-38.32,12.87-62.25,7.64-95.38,0.41c-2.51-0.55-5.05-1.1-7.65-1.66c1.38,2.93,3.06,5.96,4.63,8.07c0.11,0.15,0.22,0.3,0.32,0.46  l16.96,25.88l9.31-2.97c4.85-1.54,10.06,1,11.81,5.79c1.75,4.78-0.58,10.09-5.29,12.04l-75.09,31.11  C436,272.56,434.77,272.79,433.55,272.79z"
                    />
                    <path
                      d="M477.56,299.9c-3.79,0-7.37-2.28-8.84-6.02c-1.92-4.88,0.48-10.4,5.36-12.32l74.62-29.4c4.88-1.92,10.4,0.48,12.32,5.36  c1.92,4.88-0.48,10.4-5.36,12.32l-74.62,29.4C479.9,299.68,478.72,299.9,477.56,299.9z"
                    />
                    <path
                      d="M629.87,295.5c-8.56,0-16.82-4.56-21.19-12.39l-30.2-54.1c-2.56-4.58-0.92-10.37,3.67-12.92  c4.58-2.56,10.37-0.92,12.92,3.67l30.2,54.1c1.26,2.26,4.03,3.25,6.44,2.3l10.19-4.02c2.96-1.17,4.94-4.09,4.92-7.27l-0.52-75.27  c-0.04-5.25,4.19-9.53,9.43-9.57c0.02,0,0.05,0,0.07,0c5.22,0,9.46,4.21,9.5,9.43l0.52,75.27c0.08,10.98-6.74,21.06-16.95,25.08  l-10.2,4.02C635.81,294.96,632.82,295.5,629.87,295.5z"
                    />
                    <path class="st0" d="M575.53,149.13" />
                    <path
                      d="M575.53,158.63c-0.76,0-1.54-0.09-2.31-0.29c-5.09-1.27-8.19-6.43-6.91-11.52l10.48-41.93c1.63-6.51,6.33-11.87,12.58-14.33  l21.56-8.49c5.18-2.04,10.92-1.63,15.75,1.11c4.77,2.71,8.05,7.34,9,12.73l7.34,35.66c1.06,5.14-2.25,10.16-7.39,11.22  c-5.13,1.06-10.16-2.25-11.22-7.39l-7.28-35.36l-20.8,8.2c-0.55,0.22-0.97,0.69-1.11,1.26l-10.48,41.93  C583.66,155.75,579.79,158.63,575.53,158.63z"
                    />
                  </svg>

                  <span style="margin-right: -30px"> {{ $t("Flight") }}</span>
                </div>
              </li>
            </ul>

            <hotel-search
              v-if="tabIndex == hotelCurrentTab && hotelAccessibility"
              :selectedHotel="onSelectedHotel"
              :hotelList="hotels"
              :cityList="cities"
            />
            <PdkSearch
              v-if="tabIndex == tourCurrentTab"
              :selectedHotel="onSelectedHotel && tourAccessibility"
              :selectedDestination="onSelectedDest"
              :originList="originList"
              :destinationList="destinations"
            />
            <flight-search
              v-if="tabIndex == flightCurrentTab"
              :selectedHotel="onSelectedHotel"
              :selectedDestination="onSelectedDest"
              :originList="originList"
              :destinationList="destinations"
            />
          </div>
        </div>
      </div>

      <div class="container-fluid about-pardis-dariush hotels-list-carousel">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="curved-shape1 fix-shap-footer"
          fill="#f5f7f9"
          id="Layer_1"
          data-name="Layer 1"
          viewBox="0 0 1500 154.5"
        >
          <path
            class="cls-1"
            d="M0,117.11v62H1500v-62s0-90.59-101.4-92c-91.07-1.28-546.32.37-681.5.37-127.36,0-507.58-.32-618.77-.37C0,25.05,0,117.11,0,117.11Z"
            transform="translate(0 -24.61)"
          />
        </svg>

        <div class="main_title">
          <h2>{{ $t("HomeBody.SuggestedHotelsForYou") }}</h2>
          <!-- <p>لیست هتل های پیشنهادی ما در ایران</p> -->
        </div>

        <div class="row" v-if="!isMobile">
          <div
            v-for="(item, index) in hotelList"
            v-bind:key="index"
            class="
              col-lg-3 col-md-6
              wow
              zoomIn
              recommended-hotels
              d-none d-md-block
            "
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: zoomIn;
            "
          >
            <div
              style="padding-bottom: 10px"
              class="tour_container"
              v-if="localee == 'fa'"
            >
              <div class="img_container">
                <a>
                  <img
                    :src="item.imageUrl"
                    width="800"
                    height="533"
                    class="img-fluid"
                    alt="image"
                  />
                  <div class="btn-add-to-hotel">
                    <button
                      @click="onSelectHotel(item)"
                      v-if="item.hotelId === 4 || item.hotelId === 14"
                      type="button"
                      class="
                        tooltip_flip tooltip-effect-1
                        btn-color btn-circle btn-xl
                      "
                    >
                      <i class="icon-location-1"></i>

                      <span class="tooltip-content-flip"
                        ><span class="tooltip-back">{{
                          $t("HomeBody.ChooseDestination")
                        }}</span></span
                      >
                    </button>
                  </div>
                </a>
              </div>
              <div class="hotels-title faa">
                {{ item.title }}
                <h5 class="price"> </h5>

                <div class="hotel-city-name">
                  <span class="hotel-city-name-tag">
                    {{ item.location.fullName }}<span class="price"> </span>
                  </span>
                </div>
              </div>

              <div class="custom_tour_title tour_title">
                <hotel-stars style="margin-top: -6px" />
                <span
                  style="font-size: 13px; color: black"
                  v-if="
                    !readMoreHotel[item.hotelId] && item.description.length < 60
                  "
                  >{{ item.description.split("...")[0] }}</span
                >
                <span
                  style="font-size: 13px; color: black"
                  v-if="
                    !readMoreHotel[item.hotelId] && item.description.length > 60
                  "
                  >{{ item.description.substring(0, 60) }} ...</span
                >
                <div
                  style="margin-top: 8px; text-align: justify"
                  v-if="readMoreHotel[item.hotelId]"
                >
                  {{ item.description.split("...")[1] }}
                </div>
                <span
                  style="float: left"
                  v-if="item.description.includes('...')"
                >
                  <span
                    class="read-more"
                    @click="showLessHotel(item.hotelId)"
                    v-if="readMoreHotel[item.hotelId]"
                    >{{ $t("HomeBody.Close") }}</span
                  >
                  <span
                    class="read-more"
                    @click="showMoreHotel(item.hotelId)"
                    v-else
                    >{{ $t("HomeBody.ReadMore") }}</span
                  >
                </span>
              </div>
            </div>
            <div style="padding-bottom: 10px" class="tour_container" v-else>
              <div class="img_container">
                <a>
                  <img
                    :src="item.imageUrl"
                    width="800"
                    height="533"
                    class="img-fluid"
                    alt="image"
                  />
                  <div class="btn-add-to-hotel">
                    <button
                      @click="onSelectHotel(item)"
                      v-if="item.hotelId === 4 || item.hotelId === 14"
                      type="button"
                      class="
                        tooltip_flip tooltip-effect-1
                        btn-color btn-circle btn-xl
                      "
                    >
                      <i class="icon-location-1"></i>

                      <span class="tooltip-content-flip"
                        ><span class="tooltip-back">{{
                          $t("HomeBody.ChooseDestination")
                        }}</span></span
                      >
                    </button>
                  </div>
                </a>
              </div>
              <div>
                <div
                  v-for="hotelss in hotelsList"
                  :key="hotelss.hotelId"
                  class="hotels-title enn"
                >
                  <div v-if="hotelss.hotelId == item.hotelId">
                    <!-- {{ item.englishName }} -->
                    <h4>
                      {{ hotelss.englishName }}
                    </h4>
                    <h5 class="price"> </h5>

                    <div class="hotel-city-name">
                      <span class="hotel-city-name-tag">
                        {{ item.location.fullName }}<span class="price"> </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="custom_tour_title tour_title">
                <hotel-stars style="margin-top: -6px" />
             
              </div>
            </div>
            <!-- End box tour -->
          </div>
          <!-- End col -->

          <div
            v-for="(item, index) in 4 - hotelList.length"
            v-bind:key="'N' + index"
            class="col-lg-3 col-md-6 wow zoomIn"
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: zoomIn;
            "
          >
            <div class="tour_container">
              <div class="img_container">
                <a>
                  <img
                    src="img/tour_box_1.jpg"
                    width="800"
                    height="533"
                    class="img-fluid"
                    alt="image"
                  />
                  <div class="custom-short_info short_info">
                    <i class="icon-ok-5"></i>هتل تست<span class="price"> </span>
                  </div>
                </a>
              </div>
              <div class="tour_title">
                <h3>هتل تست توضیحات</h3>
                <hotel-stars />
                <!-- end rating -->
                <div class="wishlist">
                  <a class="tooltip_flip tooltip-effect-1"
                    >+<span class="tooltip-content-flip"
                      ><span class="tooltip-back"
                        >انتخاب به عنوان مقصد</span
                      ></span
                    ></a
                  >
                </div>
                <!-- End wish list-->
              </div>
            </div>
            <!-- End box tour -->
          </div>
          <!-- End col -->
        </div>
        <div v-else>
          <carousel
            class="d-md-none recommended-hotels"
            :items="1"
            :dots="true"
            :nav="false"
            :autoplay="true"
            :smartSpeed="1500"
            :autoplayTimeout="8500"
            dir="ltr"
            v-if="hotelList.length > 0"
          >
            <div
              class="wow zoomIn recommended-hotels"
              v-for="(item, index) in hotelList"
              :key="index"
            >
              <img :src="item.imageUrl" />
              <div class="btn-add-to-hotel">
                <button
                  @click="onSelectHotel(item)"
                  v-if="item.hotelId === 4 || item.hotelId === 14"
                  type="button"
                  class="
                    tooltip_flip tooltip-effect-1
                    btn-color btn-circle btn-xl
                  "
                >
                  <i class="icon-location-1"></i>

                  <span class="tooltip-content-flip"
                    ><span class="tooltip-back">{{
                      $t("HomeBody.ChooseDestination")
                    }}</span></span
                  >
                </button>
              </div>
              <div class="row short_info custom-short_info">
                <div class="col-md-7">
                  <i class="icon-ok-5"></i>{{ item.title
                  }}<span class="price"> </span>
                </div>
                <div class="col-md-5" style="text-align: end">
                  {{ item.location.fullName }}<span class="price"> </span>
                </div>
              </div>
            </div>

            <!-- End box tour -->

            <!-- End col -->
          </carousel>
        </div>
        <!-- End col -->
      </div>

      <!-- Slider main container -->
      <div class="container-fluid about-pardis-dariush">
        <svg
          class="curved-shape1"
          fill="#f5f7f9"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          viewBox="0 0 1500 103.06"
          style="enable-background: new 0 0 1500 103.06"
          xml:space="preserve"
        >
          <path
            class="st0"
            d="M0,103.06h1500c0,0,0-90.59-101.4-92.01c-91.07-1.28-546.33,0.36-681.51,0.36  c-127.36,0-507.58-0.32-618.77-0.36C0,11,0,103.06,0,103.06z"
          />
        </svg>
        <div class="row">
          <div class="col-sm-12 col-lg-7 about-pardis-left">
            <div class="row about-counter">
              <div class="about-more-h">
                <h3>{{ $t("HomeBody.SuggestedHotelsForYou") }}</h3>
                <p>
                  {{ $t("HomeBody.AboutPardisDescription") }}
                </p>
                <p>
                  {{ $t("HomeBody.AboutPardisDescription2") }}
                </p>
              </div>
              <div class="col-lg-4 col-6 first-link">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-6"></i></p>
                  <h4>
                    <a target="blank" href="http://dariushgrandhotel.com">
                      {{ $t("HomeBody.DariushGrandhotel") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon">
                    <img
                      src="/img/dolphin.png"
                      alt="پارک دلفین"
                      style="width: 100%; padding: 9px"
                    />
                  </p>
                  <h4>
                    <a target="blank" href="http://dp.dariushgroup.com">
                      {{ $t("HomeBody.DolphinariumAndBirdsGarden") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-41"></i></p>
                  <h4>
                    <a target="blank" href="http://ts.dariushgroup.com">
                      {{ $t("HomeBody.FastTrackAndLounge") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="pe-7s-plane"></i></p>
                  <h4>
                    <a target="blank" href="http://www.zagrosairlines.com">
                      {{ $t("HomeBody.ZagrosAirlne") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-6"></i></p>
                  <h4>
                    <a target="blank" href="http://www.hotelsimorgh.com/">
                      {{ $t("HomeBody.MashhadHotelSimorgh") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-32"></i></p>
                  <h4>
                    <a target="blank" href="">
                      {{ $t("HomeBody.ImprovementAndManagementDepartment") }}
                    </a>
                  </h4>
                </div>
              </div>

              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-32"></i></p>
                  <h4>
                    <a target="blank" href="">
                      {{ $t("HomeBody.TourismServicesDepartment") }}
                    </a>
                  </h4>
                </div>
              </div>
              <div class="col-lg-4 col-6">
                <div class="counter-item">
                  <p class="icon"><i class="icon_set_1_icon-32"></i></p>
                  <h4>
                    <a target="blank" href="">
                      {{ $t("HomeBody.ElectronicTourismDepartment") }}
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-lg-5 pardis-transparent-banner">
            <img src="/img/leftholdingtrans154512.webp" alt="هُلدینگ" />
          </div>
        </div>
      </div>
      <div class="container-fluid margin_container">
        <div class="main_title">
          <h2>
            <span>
              {{ $t("News.NewsAndEvents") }}
            </span>
            {{ $t("HomeBody.DariushGrandhotel") }}
          </h2>

          <!-- <p>لیست هتل های پیشنهادی ما در ایران</p> -->
        </div>

        <div class="row" v-if="!isMobile">
          <div
            v-for="(item, index) in newsList"
            v-bind:key="'N' + index"
            class="col-md-4 wow zoomIn"
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: zoomIn;
            "
          >
            <div class="tour_container news-sec">
              <div class="news_img_container">
                <a>
                  <img
                    :src="'data:image/jpeg;base64,' + item.image"
                    class="img-fluid"
                    alt="image"
                  />
                </a>
              </div>
              <div class="news_title_container">
                <a
                  target="_blank"
                  class="news_title"
                  :href="`http://blog.dariushgrandhotel.com/fa/Post/GetDetail/${item.code}`"
                  >{{ item.faTitle }}</a
                >
                <div class="news-abs">{{ item.faSummary }}</div>
              </div>
              <div class="news-more">
                <a
                  target="_blank"
                  class="read_more btn"
                  :href="`http://blog.dariushgrandhotel.com/fa/Post/GetDetail/${item.code}`"
                >
                  <span> {{ $t("HomeBody.ReadMore") }} </span></a
                >
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <carousel
            class="d-md-none recommended-hotels"
            :items="1"
            :dots="true"
            :nav="false"
            :autoplay="true"
            :smartSpeed="1500"
            :autoplayTimeout="8500"
            dir="ltr"
          >
            <div
              v-for="(item, index) in newsList"
              v-bind:key="'N' + index"
              class="wow zoomIn"
              data-wow-delay="0.1s"
              style="
                visibility: visible;
                animation-delay: 0.1s;
                animation-name: zoomIn;
              "
            >
              <div class="tour_container news-sec">
                <div class="news_img_container">
                  <a>
                    <img
                      :src="'data:image/jpeg;base64,' + item.image"
                      class="img-fluid"
                      alt="image"
                    />
                  </a>
                </div>
                <div class="news_title_container">
                  <a
                    target="_blank"
                    class="news_title"
                    :href="`http://blog.dariushgrandhotel.com/fa/Post/GetDetail/${item.code}`"
                    >{{ item.faTitle }}</a
                  >
                  <div class="news-abs">{{ item.faSummary }}</div>
                </div>
                <div class="news-more">
                  <a
                    target="_blank"
                    class="read_more btn"
                    :href="`http://blog.dariushgrandhotel.com/fa/Post/GetDetail/${item.code}`"
                    ><span> {{ $t("HomeBody.ReadMore") }} </span></a
                  >
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
      <div class="custom_white_bg">
        <!-- <div class="container margin_container_home">
          <div class="banner colored">
            <div>پارک دلفین های کیش</div>
            <p>
              از جذاب ترین و شناخته شده ترین تفریحات کیش است که هر گردشگر با هر
              سن و سلیقه ای از بازدید آن خاطره ای به یاد ماندنی خواهد داشت
            </p>
            <a href="https://dp.dariushgroup.com" target="_blank" class="btn_1 white">رزرو</a>
          </div>
        </div> -->
        <div class="container-fluid margin_container">
          <div class="second_title">
            <!-- <h2 v-if="$i18n.locale[fa]">  {{ $t('HomeBody.Tours') }}  <span class="dest-list-title">{{ $t('HomeBody.Proposed') }}</span> {{ $t('HomeBody.We') }}</h2> -->
            <h2>{{ $t("HomeBody.ToursProposed") }}</h2>
          </div>
          <div class="">
            <div class="row">
              <div
                v-for="(item, index) in destinationList"
                v-bind:key="index"
                style="padding: 15px !important"
                class="col-lg-4 col-sm-6 mb-3 mb-lg-0 px-0"
              >
                <div class="hover hover-1 text-white fullrow">
                  <img
                    style="width: 100% !important; height: 100% !important"
                    :src="
                      item.location.locationImages[0]
                        ? item.location.locationImages[0].imageUrl
                        : 'img/tour_box_1.jpg'
                    "
                  />
                  <div class="hover-overlay"></div>
                  <div
                    @click="onSelectDestination(item)"
                    class="hover-1-content px-5 py-4"
                  >
                    <span class="tooltip-content-flip"
                      ><span class="tooltip-back">
                        {{ $t("HomeBody.Tours") }}
                      </span></span
                    >
                    <h3 class="hover-1-title text-uppercase mb-0">
                      {{ item.title }}
                    </h3>
                    <p class="hover-1-description font-weight-light mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <PdkFooter />
  </div>
</template>

<script>
import Banner from "@/components/tour/TourBanner";
import PdkSearch from "@/components/tour/Search";
import PdkHeader from "@/components/PdkHeader";
import Store from "../tour/store/index";
import HotelStars from "../../components/tour/HotelStars.vue";
import HotelSearch from "../../components/hotel/HotelSearchHome";
import PdkFooter from "@/components/PdkFooter";
import RoomSlider from "../../components/hotel/RoomSlider";
import FlightSearch from "../../components/flight/FlightSearch";
import carousel from "vue-owl-carousel2";
import GoToSurvey from "../../components/club/GoToSurvey.vue";
import HotelIndex from "../../components/hotel/HotelIndex.vue";
// import { Swiper, SwiperSlide } from "swiper/vue";

require("linqjs");

export default {
  name: "Home",
  store: Store,
  components: {
    HotelStars,
    Banner,
    PdkSearch,
    PdkHeader,
    HotelSearch,
    PdkFooter,
    RoomSlider,
    FlightSearch,
    carousel,
    HotelIndex,
  },

  data: () => ({
    isResultNotFound: false,
    hotelList: [],
    hotelsList: [],
    newsList: [],
    hotels: [],
    originList: [],
    destinations: [],
    destinationList: [],
    specialDestination: {},
    selectedHotel: null,
    selectHotel: null,
    selectedDest: null,
    readMoreHotel: {},
    tabIndex: 1,
    localee: "fa",
    cities: [],
    mainSearchAccessibility: [],
    hotelAccessibility: false,
    tourAccessibility: false,
    flightAccessibility: false,
    hotelCurrentTab: 1,
    tourCurrentTab: 2,
    flightCurrentTab: 3,
    checkMenuList: false,
    isMobile: true,
  }),
  async created() {
    this.getHotelList();
    this.getDestinationList();
    this.getLocationList();
    this.getDariushHotelNewsList();
  },
  mounted: function () {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
    onSelectedHotel: function () {
      return this.selectedHotel;
    },
    // swiper() {
    //   return this.$refs.mySwiper.$swiper;
    // },
    onSelectedDest: function () {
      return this.selectedDest;
    },
    checkSourceId() {
      if (localStorage.getItem("SourceIdInReport") !== null) {
        this.tabIndex = 1;
        return true;
      } else {
        this.tabIndex = 10;
        return false;
      }
    },
    getAccessibility() {
      // this.mainSearchAccessibility = this.$store.getters.GetMenuList;
      this.checkMenuList = false;
      if (localStorage.getItem("menuList") !== null)
        this.$store.dispatch("changeMenuItemStatus", true);

      const checkValue = this.$store.getters.GetMenuItemStatus;
      if (checkValue === true) this.checkMenuList = true;

      if (this.checkMenuList === true) {
        this.mainSearchAccessibility = JSON.parse(
          localStorage.getItem("menuList")
        );
        let currentTab = 1;

        const checkHomeLength = this.mainSearchAccessibility.filter(
          (p) => p.name === "homeSearch"
        );

        if (
          this.mainSearchAccessibility.length != 0 &&
          checkHomeLength.length != 0
        ) {
          this.mainSearchAccessibility = this.mainSearchAccessibility.filter(
            (p) => p.name === "homeSearch"
          )[0].children;
          if (
            this.mainSearchAccessibility.filter((p) => p.name === "hotelresult")
              .length
          ) {
            this.hotelAccessibility = true;
            this.hotelCurrentTab = currentTab;
            currentTab += currentTab;
          }

          if (
            this.mainSearchAccessibility.filter((p) => p.name === "hotelFlight")
              .length
          ) {
            this.tourCurrentTab = currentTab;
            this.tourAccessibility = true;
          }
        }
        return this.checkMenuList;
      }
    },
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
    checkLocale() {
      this.localee = this.$i18n.locale;
      // alert(this.localee);
      console.log(this.localee);
    },
    showMoreHotel(id) {
      this.$set(this.readMoreHotel, id, true);
    },
    showLessHotel(id) {
      this.$set(this.readMoreHotel, id, false);
    },
    onSelectHotel(item) {
      this.selectedHotel = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
        hotelId: item.hotelId,
      };
      return this.selectedHotel;
    },
    mapHotelItem(item) {
      const data = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        icon: " ",
        hotelId: item.hotelId,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
      };
      switch (data.hotelId) {
        case 4:
          data.icon = " Dariush Grand Hotel";
          break;
        case 8:
          data.icon = " Shiraz Grand Hotel";
          break;
        case 9:
          data.icon = " Sinour Hotel";
          break;
        case 14:
          data.icon = " Simorgh Hotel";
      }
      this.hotelsList.push(data);
      return data;
    },
    mapHotelData() {
      var locale = this.localee;
      this.hotelList.forEach((element) => {
        const data = this.mapHotelItem(element);
        // debugger;
        switch (data.hotelId) {
          case 4:
            data.englishName = " Dariush Grand Hotel";
            break;
          case 8:
            data.englishName = " Shiraz Grand Hotel";
            break;
          case 9:
            data.englishName = " Sinour Hotel";
            break;
          case 14:
            data.englishName = " Simorgh Hotel";
        }
        console.log("English Name " + data.englishName);

        this.hotels.push(data);
      });

      this.hotelList.map((x) => {
        x.location.fullName =
          this.$i18n.messages[locale].Locations["location" + x.locationId];
      });
    },

    onSelectDestination(item) {
      this.tabIndex = 2;

      this.selectedDest = {
        englishName: item.englishName,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "City",
      };
    },
    async getHotelList() {
      // const loader = this.$loading.show();
      let hotels = await this.$store.dispatch("unauthorized/GetHotelList");
      hotels.sort((b) => b.title);
      // debugger;
      if (Array.isArray(hotels)) {
        this.hotelList = hotels;
        this.mapHotelData();
      }
      // loader.hide();
    },
    async getDariushHotelNewsList() {
      // const loader = this.$loading.show();

      let news = await this.$store.dispatch(
        "unauthorized/GetDariushHotelNewsList"
      );

      if (Array.isArray(news)) {
        this.newsList = news;
      }

      // loader.hide();
    },

    async getDestinationList() {
      const destinations = await this.$store.dispatch(
        "unauthorized/GetDestinationList"
      );

      if (Array.isArray(destinations)) {
        // debugger;
        var locale = this.localee;
        this.destinationList = destinations;
        this.specialDestination = destinations.where(
          (d) => d.location.isoCode == "KIH"
        );
        this.destinationList.map((x) => {
          x.title =
            this.$i18n.messages[locale].Locations["location" + x.locationId];
        });
        console.log(" Destination i " + this.destinationList);
      }
    },
    async getLocationList() {
      this.originList = await this.$store.dispatch("unauthorized/getLocations");

      //redtrict destinations
      this.destinations = this.originList.data.filter(
        (p) => p.iata == "KIH" || p.iata == "MHD"
      );

      //redtrict cities
      this.cities = this.originList.data.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
  },
};
</script>
<style lang="css" scoped>
.nav-tabs {
  border-bottom: none !important;
}

.search-widget .custom-search-input-2 {
  background-color: rgba(255, 255, 255, 0.88);
  border-radius: 0 0 30px 30px;
}

.search-title {
  color: #175488;
  font-size: 28px;
  font-weight: 700;
}

.style-title-text {
  position: absolute;
  bottom: 500px;
  right: -50px;
  z-index: 10;
}

.active_tab {
  background: rgba(255, 255, 255, 0.9) !important;
}

.active_tab:hover {
  background: rgba(255, 255, 255, 0.8) !important;
}

.custom_tour_title {
  min-height: 115px !important;
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}

.tooltip-content-flip .tooltip-back::after {
  left: 45%;
  border-top: 0px solid transparent !important;
  /* border-right: 10px solid transparent; */
}

.tooltip-content-flip {
  position: absolute;
  z-index: 9;
  width: 80px;
  height: 45px;
  right: -240% !important;
  top: -27% !important;
  text-align: center;
  color: #fff;
  opacity: 0;
  margin-top: 7px !important;
  background: #00c3e1 !important;
  border-radius: 20px;
  cursor: default;
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s;
}

.tooltip-back {
  padding: 5px;
  background: #00c3e1;
  border: 2px solid #11567896;
  border-radius: 5px !important;
  font-size: 12px;
  /* line-height: 14px; */
  /* padding-top: 25px; */
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
}

.main-secret-slider img {
  width: 100%;
}

.search-widget {
  position: relative;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: transparent !important;
}

.img_container a img {
  height: 240px !important;
  min-height: 250px !important;
  border-radius: 20px;
}

.news_img_container a img {
  width: 100%;
  border-radius: 20px;
}

.custom-short_info {
  padding: 45px 0px 8px 0px !important;
  margin-left: 0px;
  padding-left: -18px;
  margin-right: 0px;
}

.btn-add-to-hotel {
  position: absolute;
  top: 0;
  right: 0;
  width: 65px;
  height: 77px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  /* background: url(../img/badge_save.png); */
  font-size: 11px;
  line-height: 12px;
  padding-top: 10px;
  right: inherit;
  left: 0;
}

.read-more {
  font-size: 11px;
  color: #198cfb;
}

.read-more:hover {
  cursor: pointer;
  font-size: 12px;
  color: #0c79df;
}

om_white_bg {
  padding-top: 25px;
  padding-bottom: 15px;
}

.margin_container {
  padding: 1% 8%;
}

.cityImage {
  width: auto;
  height: auto;
}

.hover {
  overflow: hidden;
  position: relative;
  padding-bottom: 60%;
}

.fullrow {
  height: 100% !important;
  border-radius: 20px;
}

.hover-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 90;
  transition: all 0.4s;
}

.hover img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  height: fit-content;
  width: fit-content !important;
}

.hover-content {
  position: relative;
  z-index: 99;
}

.hover-1 img {
  width: 105%;
  position: absolute;
  top: 0;
  left: 0%;
  transition: all 0.3s;
}

.hover-1-content {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  transition: all 0.4s;
  cursor: pointer;
}

.hover-1 .hover-overlay {
  background: rgba(213, 171, 61, 0.7);
  opacity: 0;
}

.hover-1-description {
  transform: translateY(0.5rem);
  transition: all 0.4s;
  opacity: 0;
}

.hover-1:hover .hover-1-content {
  bottom: 2rem;
}

.hover-1:hover .hover-1-description {
  opacity: 1;
  transform: none;
}

.hover-1:hover img {
  left: 0;
}

.hover-1:hover .hover-overlay {
  opacity: 1;
}

.wishlist a {
  color: transparent;
  cursor: pointer;
  display: block;
}

.hover-1-content h3 {
  color: rgb(255, 240, 240);
  text-shadow: 2px 2px 1px #2a2a2a, 0px 5px 3px #20333c;
}

.btn-circle.btn-xl {
  width: 40px;
  height: 40px;
  border-radius: 35px;
  font-size: 24px;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}

.btn-color {
  color: #fff;
  background-color: #00c3e1 !important;
  border-color: #2b68adc4 !important;
}

.banner div {
  font-size: 24px;
  font-weight: 500;
  line-height: 48px;
}

.banner a {
  width: 100px;
  text-align: center;
  font-size: 14px;
}

.btn_tab {
  width: 87px;
  height: 50px;
  text-align: center;
  background: #b4b3b3;
  color: #fefefe;
  border-radius: 0px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.btn_tab:hover {
  background: #90908f;
}

#eeb61f .btn_tab div {
  font-size: 16px;
  text-align: center;
}

.search-title {
  text-align: center;
  margin-bottom: 0;
  /* margin-top: 10%; */
}

.search-title h2 {
  color: #3c5eb3;
  font-size: 28px;
  font-weight: 700;
}

.search-box {
  padding: 5% 7% 5% 9%;
  border-radius: 10px;
}

.highlighted-date .vpd-day-text {
  color: #ef6c00 !important;
}

.reserve-explorer {
  color: #444;
}

.news_title_container {
  min-height: 110px;
  padding: 10px;
}

.news_title {
  font-size: 15px;
  font-weight: bold;
  justify-content: initial;
  color: rgb(90, 90, 90);
}

.news_title:hover {
  color: rgb(4 112 167);
}

.reserve-explorer-item {
  border-bottom: none !important;
  width: 33.33%;
}

.reserve-explorer-item:first-child .reserve-explorer-tab {
  border-radius: 0 25px 0 0;
}

.reserve-explorer-item:last-child .reserve-explorer-tab {
  border-radius: 25px 0 0 0;
}

.reserve-explorer-item .reserve-explorer-tab {
  background: #ebeaea;
  color: #000;
  border-bottom: 0 !important;
  width: 100% !important;
  padding-top: 10px;
}

.reserve-explorer-item .reserve-explorer-tab.active_tab {
  background: #fafbfb  !important;
  padding-top: 10px;
}

.reserve-explorer-item .reserve-explorer-tab:hover {
  background: #ede6d7;
  cursor: pointer;
}

.reserve-explorer-item svg {
  width: 31px;
}

.reserve-explorer-item svg.hotef {
  width: 66px;
}

.reserve-explorer-item span {
  font-size: 17px;
  font-weight: 500;
  margin-right: 5px;
  vertical-align: sub;
}

.about-pardis-dariush {
  padding: 0 10% 50px;
  position: relative;
}

.recommended-hotels {
  z-index: 99;
}

.about-pardis-dariush .main_title {
  z-index: 999;
  display: flex;
  padding-top: 40px;
  margin-bottom: 20px;
  margin-right: 10px;
  position: relative;
}

.about-pardis-dariush .main_title h2 {
  z-index: 999;
  margin-top: 0;
  margin-bottom: 15px;
}

.about-pardis-dariush .about-pardis-right {
  padding: 0 10px 10px 7%;
  z-index: 100;
}

.about-pardis-dariush .about-pardis-right h3 {
  font-size: 25px;
  font-weight: 600;
}

.about-pardis-dariush .about-pardis-right p {
  font-size: 16px;
  font-weight: 200;
  line-height: 2;
  margin: 15px 6px;
  text-align: justify;
}

.about-pardis-dariush .about-pardis-left {
  padding: 10px 15px 30px;
  z-index: 100;
}

.about-pardis-dariush .about-pardis-left .about-counter .counter-item {
  text-align: center;
  border: 2px dashed #dde3e9;
  padding: 55px 5px 30px;
  margin: 8px 20px 0;
  position: relative;
  border-radius: 7px;
}
.about-pardis-dariush .about-pardis-left .about-counter .counter-item h4 {
  font-size: 16px;
  line-height: 1.6;
}
.about-pardis-dariush
  .about-pardis-left
  .about-counter
  .first-link
  .counter-item::before {
  content: " ";
  position: absolute;
  width: 60px;
  height: 150px;
  background-image: url(/img/persepoliscolumns3.svg);
  background-size: contain;
  right: -50%;
  background-repeat: no-repeat;
  top: 58px;
}
.about-pardis-dariush .about-pardis-left .about-counter .col-lg-4 {
  padding: 20px !important;
}

.about-pardis-dariush
  .about-pardis-left
  .about-counter
  .col-lg-4:nth-child(7)
  .counter-item::after {
  content: " ";
  position: absolute;
  width: 65px;
  height: 150px;
  background-image: url(/img/persepoliscolumns3.svg);
  background-size: contain;
  left: -50%;
  background-repeat: no-repeat;
  top: -115px;
}
.about-pardis-dariush .about-pardis-left .about-counter .counter-item .icon {
  font-size: 32px;
  margin: 0px 0 25px;
  color: #00c3e1;
  position: absolute;
  right: 32%;
  top: -32px;
  border-radius: 50%;
  background: #fafbfc;
  height: 70px;
  width: 70px;
  margin: 0;
  border: 2px dashed #b6bec5;
  border-bottom: none;
  line-height: 2.1;
}
.about-pardis-dariush .about-pardis-left .about-counter .counter-item a {
  color: #32325d;
}
.news-sec .news-abs {
  line-height: 2;
  margin: 15px 10px 20px;
  min-height: 100px;
}

.news-sec .news-more {
  text-align: center;
}

.news-sec .news-more .read_more {
  border-radius: 25px;
  background: #00c3e1;
  padding: 8px 40px 12px;
  margin-bottom: -22px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}

.btn-circle.btn-xl {
  font-size: 22px !important;
  background-color: #00c3e1 !important;
}

.about-more-h p {
  text-align: justify;
}
#hotels {
  box-shadow: none !important;
}
@media (max-width: 350px) {
  .style-title-text {
    bottom: 225px !important;
    font-size: 16px;
  }
  .about-pardis-dariush .curved-shape1 {
    top: -137px !important;
  }
  .style-title-text p {
    font-size: 16px;
  }
  .main_title h2 {
    font-size: 19px;
  }
  .main_title {
    margin-top: 20px;
    padding-top: 40px;
  }

  .panel-dropdown a:after {
    top: -17px;
  }
  .tour_container {
    margin: 0 !important;
  }
  #header_menu {
    padding: 20px 25px !important;
  }
  .search-title h2 {
    font-size: 17px;
    margin-top: 50px;
  }
}
@media (max-width: 575.99px) {
  .search-box {
    z-index: 9999;
  }
  .pardis-transparent-banner img {
    width: 120%;
    margin-top: 0;
    max-width: 120%;
    margin-right: -10%;
  }
  .about-pardis-dariush.hotels-list-carousel {
    padding: 0 3%;
  }
  .about-pardis-dariush .main_title h2 {
    margin-top: 0;
  }
  .about-more-h h3 {
    font-size: 19px;
  }
  .about-pardis-dariush
    .about-pardis-left
    .about-counter
    .col-lg-4:nth-child(odd) {
    padding-right: 25px !important;
    padding-left: 5px !important;
  }
  .about-pardis-dariush
    .about-pardis-left
    .about-counter
    .col-lg-4:nth-child(even) {
    padding-left: 25px !important;
    padding-right: 5px !important;
  }
  .about-pardis-dariush .about-pardis-left .about-counter .counter-item {
    text-align: center;
    padding: 35px 4px 20px;
    margin: 5px -10px;
    position: relative;
    border-radius: 18px;
  }
  .about-pardis-dariush .about-pardis-left .about-counter .counter-item .icon {
    font-size: 25px;
    margin: 0 0 25px !important;
    right: 31%;
    top: -30px;
    border-radius: 50%;
    height: 55px;
    width: 55px;
    border-bottom: none;
    margin: 0;
    line-height: 2.3;
  }
  .about-pardis-dariush
    .about-pardis-left
    .about-counter
    .first-link
    .counter-item::before {
    width: 60px;
    height: 150px;
    right: -39%;
    top: 85px;
  }
  .about-pardis-dariush
    .about-pardis-left
    .about-counter
    .col-lg-4:last-child
    .counter-item[data-v-5e7337c8]::after {
    width: 60px;
    height: 150px;
    left: -41%;
    top: -51px;
  }
  .about-pardis-dariush .about-pardis-left h4 {
    font-size: 14px;
  }
  .about-pardis-dariush .curved-shape1 {
    top: -35px !important;
    z-index: 2 !important;
  }
  .search-title h2 {
    font-size: 20px;
    margin-top: 70px;
  }
  .d-xs-none {
    display: none !important;
  }

  .col-md-1 {
    flex: 0 0 17%;
    max-width: 17%;
  }
  .style-title-text {
    position: absolute;
    bottom: 300px;
    right: 50px;
    z-index: 10;
    margin: auto;
  }
  .search-title {
    color: #175488;
    font-size: 18px;
    font-weight: bold;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .about-pardis-dariush .curved-shape1 {
    top: 0;
  }
  .search-title h2[data-v-5e7337c8] {
    font-size: 23px;
    margin-top: 80px;
  }
  #search_2 {
    width: 100% !important;
  }
  .search-box {
    z-index: 9999;
  }
  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -56px !important;
  }
  .main_title {
    margin-bottom: 10px;
    margin-right: 10px;
    padding-top: 60px;
  }
  .style-title-text {
    position: absolute;
    bottom: 542px;
    right: 52px;
  }
}

/* Small devices (landscape phones, 991px and up)*/
@media (min-width: 768px) and (max-width: 991px) {
  .main_title {
    font-size: 16px;
    margin-bottom: 30px;
    margin-right: 10px;
    margin-top: 60px !important;
  }
  .news-sec .news-abs {
    display: none;
  }
  .search-title {
    color: #175488;
    font-size: 20px;
    font-weight: 700;
  }

  .style-title-text {
    position: absolute;
    bottom: 235px;
    right: 15px;
    z-index: 10;
  }
  .search-box-co {
    position: absolute;
    bottom: -18px;
    right: -33px;
    z-index: 1000;
    width: 55%;
  }
}

/* Styles for extra samll phones */

/* Medium devices (tablets, 1199px and up)*/
@media (min-width: 992px) and (max-width: 1199px) {
  .search-title {
    color: #175488;
    font-size: 30px;
    font-weight: 700;
  }

  .style-title-text {
    position: absolute;
    bottom: 550px;
    right: -10px;
    z-index: 10;
  }

  .search-box-co {
    position: absolute;
    bottom: 300px;
    right: -40px;
    z-index: 1000;
  }
}

/* Large devices (desktops, 1200px and up) */
@media (min-width: 1200px) {
  .search-title {
    color: #175488;
    font-size: 26px;
    font-weight: 700;
  }
  .pardis-transparent-banner img {
    margin-left: -50px;
  }
  .style-title-text {
    position: absolute;
    bottom: 550px;
    right: -153px;
    z-index: 10;
  }

  .search-box-co {
    position: absolute;
    bottom: 300px;
    right: -260px;
    z-index: 1000;
    width: 50%;
  }

  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -10px;
    width: 100%;
    right: 0;
    z-index: 99;
  }

  .fix-shap-footer {
    position: absolute !important;
    top: -10px !important;
  }
  .main_title {
    margin-top: -95px !important;
  }
}

.about-pardis-dariush .curved-shape1 {
  position: absolute;
  top: -10px;
  width: 100%;
  right: 0;
  z-index: 99;
}

.custom-search-input-2 {
  background: #fff !important;
}

/* just Nest Hub */
@media all and (device-width: 1024px) and (device-height: 600px) {
  .search-title {
    font-size: 25px;
    font-weight: 700;
  }

  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -30px !important;
  }
}

/*  Nest Hub Max */
@media all and (device-width: 1280px) and (device-height: 800px) {
  .search-box-co {
    position: absolute !important;
    bottom: 140px;
    right: 215px;
  }

  /* .fix-shap-footer {
    position: absolute !important;
    top: -95px !important;
  }

  .style-title-text {
    position: absolute;
    right: 300px;
    z-index: 10;
    top: -400px;
  } */
}
</style>
